import { Component, Input } from '@angular/core';
import { TableComponent } from '../../core/table/table.component';
import { ColumnComponent } from '../../core/table/column.component';

@Component({
  selector: 'app-contact-preference',
  imports: [TableComponent, ColumnComponent],
  template: ` <div class="tw-flex tw-gap-8 tw-py-8">
    <div class="tw-basis-2/3">
      <app-table
        [dataSource]="dataSource.communicationMethods"
        [pageSize]="5"
        [showPaginator]="false"
        [showSort]="false"
        [showFilter]="false"
        [showFilterButton]="false"
        [showRecordLabel]="false"
      >
        <app-column name="contactMethod" label="Contact Method" width="20%" />
        <app-column name="contactValue" label="Contact Value" width="20%" />
        <app-column
          name="communicationPreferences"
          label="Communication Preferences"
          width="20%"
        />
      </app-table>
    </div>
  </div>`,
  styles: [],
})
export class ContactPreferenceComponent {
  @Input()
  dataSource: any;
}
